<div id="dashboard">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <!-- Balance -->
        <div class="panel" id="d-balance">
          <div>
            <div class="heading">My Balance Sheet</div>
            <div>
              Balance
              <div class="select-box-container">
                <span
                  (click)="selectBoxOpen = true"
                  class="select-box-selector"
                  >{{ balanceYear }}</span
                  >
                  @if (selectBoxOpen) {
                    <selectbox
                      [value]="returnString(balanceYear)"
                      [items]="returnToStringMap(years)"
                      position="top"
                      (onChange)="onYearChange($event)"
                    ></selectbox>
                  }
                </div>
              </div>
              <div id="balance-value">{{ currentYearBalance }}</div>
            </div>
            <div>
              <div class="row">
                <div class="col-xs-9">Final balance {{ balanceYear - 1 }}</div>
                <div class="col-xs-3 text-right">
                  {{ previousYearFinalBalance }}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-9">+ Legal Holidays {{ balanceYear }}</div>
                <div class="col-xs-3 text-right">{{ offCount }}</div>
              </div>
              <div class="row">
                <div class="col-xs-9">
                  +
                  <a (click)="showDetail('EXTRA')"
                    >Extra-legal Holidays {{ balanceYear }}</a
                    >
                  </div>
                  <div class="col-xs-3 text-right">{{ eholCount }}</div>
                </div>
                <div class="row">
                  <div class="col-xs-9">
                    -
                    <a (click)="showDetail('HOLIDAYS')"
                      >Planned / Taken Holidays {{ balanceYear }}</a
                      >
                    </div>
                    <div class="col-xs-3 text-right">{{ takenCount }}</div>
                  </div>
                      </div>
                    </div>

                    <!-- Working Config Tile -->
                    @for (workingConfig of workingConfigs; track $index) {
                      <div class="panel wc-panel">
                        <div class="wc-header">
                          <i class="material-icons wc-icon">
                            {{ workingConfig.type === 'PARENTAL_LEAVE' ? 'child_care' : workingConfig.type === 'MATERNITY_LEAVE' ? 'pregnant_woman' : 'timelapse' }}
                          </i>
                          <div class="wc-title-block">
                            <div class="heading">
                              {{ workingConfig.type === 'PARENTAL_LEAVE' ? 'Parental Leave' : workingConfig.type === 'MATERNITY_LEAVE' ? 'Maternity Leave' : 'Part-Time' }}
                            </div>
                            <div class="wc-period">
                              from &nbsp;{{ workingConfig.start | date:'MMM d, y' }} {{ formatEndDate(workingConfig.end) }}
                            </div>
                          </div>
                          <div class="wc-percentage">{{ workingConfig.percentage }}%</div>
                        </div>
                        @for (rep of workingConfig.repartition; track $index; let repIdx = $index) {
                          @if (workingConfig.repartition.length > 1) {
                            <div class="wc-week-label">
                              {{ repIdx === 0 ? 'Even weeks' : 'Odd weeks' }}
                            </div>
                          }
                          <div class="wc-days">
                            @for (key of dayKeys; track key; let i = $index) {
                              <div class="wc-day" [ngClass]="getDayClass(rep, key)">
                                <span class="wc-day-name">{{ dayLabels[i] }}</span>
                                <span class="wc-day-dot">
                                  @if (rep[key] >= 1) { ● }
                                  @else if (rep[key] > 0) { ◐ }
                                  @else { ○ }
                                </span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    <!-- Outside Lux Quota -->
                    @if (maxDol !== null) {
                      <div class="panel hbw-panel" id="d-hbw">
                        <div class="hbw-header">
                          <i class="material-icons hbw-icon">home_work</i>
                          <div class="hbw-title-block">
                            <div class="heading">Days outside Luxembourg</div>
                            <div class="hbw-subtitle">{{ balanceYear }}</div>
                          </div>
                          <div class="hbw-count">
                            <span class="hbw-taken">{{ dolCount }}</span>
                            <span class="hbw-separator">/</span>
                            <span class="hbw-max">{{ maxDol }}</span>
                          </div>
                        </div>
                        <div class="hbw-bar-track">
                          <div
                            class="hbw-bar-fill"
                            [ngClass]="getDolProgressClass()"
                            [style.width]="getDolProgressWidth()">
                          </div>
                        </div>
                        @if (getDolWarningLevel() >= 80) {
                          <div class="hbw-warning-msg"
                            [class.hbw-warning-msg--danger]="getDolWarningLevel() >= 90"
                            [class.hbw-warning-msg--over]="getDolWarningLevel() >= 100">
                            <i class="material-icons">warning</i>
                            @if (getDolWarningLevel() >= 100) {
                              <span>Quota reached!</span>
                            } @else if (getDolWarningLevel() >= 90) {
                              <span>90% of quota used</span>
                            } @else {
                              <span>80% of quota used</span>
                            }
                          </div>
                        }
                        <div class="hbw-legend">
                          <a (click)="showDetail('DOL')">See details</a>
                        </div>
                      </div>
                    }

                    <!-- Sickness Card -->
                    <div class="panel sick-panel" id="d-sick">
                      <div class="sick-header">
                        <i class="material-icons sick-icon">local_hospital</i>
                        <div class="sick-title-block">
                          <div class="heading">Sickness</div>
                          <div class="sick-subtitle">{{ balanceYear }}</div>
                        </div>
                      </div>
                      <div class="sick-row">
                        <span class="sick-label">
                          <a (click)="showDetail('SICK')">Personal</a>
                        </span>
                        <span class="sick-value">{{ sickDaysCount }} day{{ sickDaysCount !== 1 ? 's' : '' }}</span>
                      </div>
                      <div class="sick-row">
                        <span class="sick-label">
                          <a (click)="showDetail('KIDS')">Kids</a>
                        </span>
                        <span class="sick-value">{{ kidsSickDaysCount }} day{{ kidsSickDaysCount !== 1 ? 's' : '' }}</span>
                      </div>
                    </div>

                    <!-- Holidays -->
                    <div
                      class="panel"
                      id="d-off-duty"
          [ngClass]="{
            pending: nextDayOff?.eventStatus == 'PENDING',
            deleted: nextDayOff?.eventStatus == 'DEL_REQUESTED'
          }"
                      >
                      <div>
                        <div class="heading">
                          My Next Holidays
                          <span>{{
                            getEventTypeDescription(nextDayOff?.eventStatus)
                          }}</span>
                        </div>
                        <div>
                          <!-- If no hoidays to come -->
                          @if (!nextDayOff) {
                            <span>No holidays foreseen</span>
                          }

                          <!-- If holidays to come -->
                          @if (nextDayOff) {
                            <ul>
                              <li class="dashboard-event">
                                <div class="event-desc">{{ nextDayOff.eventDesc }}</div>
                                <div>
                                  From
                                  <strong>{{
                                    (nextDayOff.eventStartDate | date : "MMMM d, y") +
                                    " [" +
                                    nextDayOff.eventStartPeriod +
                                    "]"
                                  }}</strong>
                                </div>
                                <div>
                                  to
                                  <strong>{{
                                    (nextDayOff.eventEndDate | date : "MMMM d, y") +
                                    " [" +
                                    nextDayOff.eventEndPeriod +
                                    "]"
                                  }}</strong>
                                </div>
                              </li>
                            </ul>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 scrollDiv">
                    <!-- Reminder -->
                    <div class="panel" id="d-reminder">
                      <div>
                        <div class="heading">My Reminder</div>
                        <div>
                          <!-- If no accepted event to come -->
                          @if (!nextEvents || nextEvents.length == 0) {
                            <span
                              >No accepted event to come</span
                              >
                            }

                            <!-- Otherwise -->
                            @if (nextEvents && nextEvents.length > 0) {
                              <span
                                >Accepted events to come</span
                                >
                              }
                            </div>
                          </div>
                          <!-- If accepted events to come -->
                          @if (nextEvents && nextEvents.length > 0) {
                            <div>
                              <ul>
                                <!-- Loop -->
                                @for (element of nextEvents; track element) {
                                  <li class="dashboard-event">
                                    <div>
                                      <strong>{{ element.eventType }}</strong
                                        >@if (element.additionalDesc) {<i
                                        class="material-icons"
                                        (click)="redirectToEventInfo(element.socialEventId)"
                                        >help_outline</i
                                        >}
                                      </div>
                                      <div class="event-desc">{{ element.eventDesc }}</div>
                                      <div
                                        class="{{ 'event-' + element.eventType.toLocaleLowerCase() }}"
                                      ></div>
                                      <div>
                                        From
                                        <strong>{{
                                          (element.eventStartDate | date : "MMMM d, y") +
                                          " [" +
                                          element.eventStartPeriod +
                                          "]"
                                        }}</strong>
                                      </div>
                                      <div>
                                        to
                                        <strong>{{
                                          (element.eventEndDate | date : "MMMM d, y") +
                                          " [" +
                                          element.eventEndPeriod +
                                          "]"
                                        }}</strong>
                                      </div>
                                      @if (selectedUser == null) {
                                        <div class="accept-decline">
                                          @if (element.invitationStatus == 'MANDATORY') {
                                            <span
                                              ><!-- For style - do not remove --></span
                                              >
                                            }
                                            @if (element.invitationStatus != 'MANDATORY') {
                                              <span
                                                class="invitation-accepted"
                                                >You accepted this event, but you may still cancel if you
                                                suddenly have pony!</span
                                                >
                                              }
                                              <div>
                                                @if (element.invitationStatus != 'MANDATORY') {
                                                  <a
                                                    class="btn btn-danger btn-fab btn-fab-mini"
                                                    title="Decline"
                                                    (click)="handleParticipationResponse(element, false)"
                                                    ><i class="material-icons">&#xE5CD;</i></a
                                                    >
                                                  }
                                                </div>
                                              </div>
                                            }
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  }
                                </div>

                                <!-- Upcoming -->
                                <div class="panel" id="d-upcoming">
                                  <div>
                                    <div class="heading">Upcoming Events</div>
                                    <div>
                                      <!-- If no upcoming events -->
                                      @if (!upcomingEvents || upcomingEvents.length == 0) {
                                        <span
                                          >No upcoming events</span
                                          >
                                        }

                                        <!-- Otherwise -->
                                        @if (upcomingEvents && upcomingEvents.length > 0) {
                                          <span
                                            >Please tell us if we'll be pleased to see you!</span
                                            >
                                          }
                                        </div>
                                      </div>
                                      <!-- If upcoming events -->
                                      @if (upcomingEvents && upcomingEvents.length > 0) {
                                        <div>
                                          <ul>
                                            <!-- Loop -->
                                            @for (element of upcomingEvents; track element) {
                                              <li
                                                class="dashboard-event"
                                                >
                                                <div>
                                                  <strong>{{ element.eventType }}</strong
                                                    ><i
                                                    class="material-icons"
                                                    (click)="redirectToEventInfo(element.socialEventId)"
                                                    >help_outline</i
                                                    >
                                                  </div>
                                                  <div class="event-desc">{{ element.eventDesc }}</div>
                                                  <div
                                                    class="{{ 'event-' + element.eventType.toLocaleLowerCase() }}"
                                                  ></div>
                                                  <div>
                                                    From
                                                    <strong>{{
                                                      (element.eventStartDate | date : "MMMM d, y") +
                                                      " [" +
                                                      element.eventStartPeriod +
                                                      "]"
                                                    }}</strong>
                                                  </div>
                                                  <div>
                                                    to
                                                    <strong>{{
                                                      (element.eventEndDate | date : "MMMM d, y") +
                                                      " [" +
                                                      element.eventEndPeriod +
                                                      "]"
                                                    }}</strong>
                                                  </div>
                                                  @if (selectedUser == null) {
                                                    <div class="accept-decline">
                                                      @if (element.invitationStatus == 'PENDING') {
                                                        <span
                                                          class="invitation-pending"
                                                          >Will you participate?</span
                                                          >
                                                        }
                                                        @if (element.invitationStatus == 'REFUSED') {
                                                          <span
                                                            class="invitation-refused"
                                                            >You declined this event, but who never changes his
                                                            mind?</span
                                                            >
                                                          }
                                                          <div>
                                                            @if (element.invitationStatus != 'ACCEPTED') {
                                                              <a
                                                                class="btn btn-success-custom btn-fab btn-fab-mini"
                                                                title="Accept"
                                                                (click)="handleParticipationResponse(element, true)"
                                                                ><i class="material-icons">&#xE5CA;</i></a
                                                                >
                                                              }
                                                              @if (element.invitationStatus != 'REFUSED') {
                                                                <a
                                                                  class="btn btn-danger-custom btn-fab btn-fab-mini"
                                                                  title="Decline"
                                                                  (click)="handleParticipationResponse(element, false)"
                                                                  ><i class="material-icons">&#xE5CD;</i></a
                                                                  >
                                                                }
                                                              </div>
                                                            </div>
                                                          }
                                                        </li>
                                                      }
                                                    </ul>
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                            <div class="col-lg-4 col-md-12">
                                              <div class="row">

                                                <!-- Calendar/Schedule -->
                                                <app-info-panel
                                                  panelId="d-planning"
                                                  [heading]="displayYears()"
                                                  description="Check out the provisional calendar!"
                                                  routerLink="/Schedule">
                                                </app-info-panel>

                                                <!-- Tutorials -->
                                                <app-info-panel
                                                  panelId="d-tuto"
                                                  heading="Need some help?"
                                                  description="Check out our tutorials!"
                                                  routerLink="/Tutorials">
                                                </app-info-panel>

                                                <!-- Twitter -->
                                                <app-follow-us-panel
                                                  panelId="d-twitter"
                                                  heading="Follow us on Twitter !"
                                                  link="https://twitter.com/xpertiz_lux">
                                                </app-follow-us-panel>

                                                <!-- Linkedin -->
                                                <app-follow-us-panel
                                                  panelId="d-linkedin"
                                                  heading="Follow us on Linkedin !"
                                                  link="https://lu.linkedin.com/company/xpertiz-s-a">
                                                </app-follow-us-panel>

                                                <!-- Mkdocs documentation -->
                                                <app-follow-us-panel
                                                  panelId="d-mkdocs-material"
                                                  heading="Check our documentation !"
                                                  link="https://xpertiz-documentation-xpertiz-38162807426ef5596eca05d86efada5e8.gitlab.io/">
                                                </app-follow-us-panel>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <!-- DETAIL MODAL -->
                                      @if (displayDetail) {
                                        <notification-modal
                                          [title]="modalLabel"
                                          [detail]="currentDetail"
                                          [type]="modalType"
                                          (onClose)="displayDetail = false"
                                          style="display: block"
                                        ></notification-modal>
                                      }
